// src/services/api.js
import axios from 'axios';

// Configuração da API
const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';

class ApiService {
  constructor() {
    this.authToken = null;
    this.api = null;
    this.initApi();
  }

  initApi() {
    this.api = axios.create({
      baseURL: API_BASE_URL,
      timeout: 30000,
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
      },
    });

    // Interceptor para adicionar token
    this.api.interceptors.request.use(
      (config) => {
        if (this.authToken) {
          config.headers['X-Auth-Hash'] = this.authToken;
        }
        console.log(`[API] ${config.method?.toUpperCase()} ${config.url}`, config.data);
        return config;
      },
      (error) => Promise.reject(error)
    );

    console.log('[API] Serviço inicializado com URL:', API_BASE_URL);
  }

  async setAuthToken(token) {
    console.log('[API] setAuthToken chamado');
    this.authToken = token;
    localStorage.setItem('userHash', token);
  }

  async loadAuthToken() {
    console.log('[API] loadAuthToken chamado');
    const token = localStorage.getItem('userHash');
    if (token) {
      this.authToken = token;
      console.log('[API] Token carregado do localStorage');
    }
    return token;
  }

  async clearAuthToken() {
    console.log('[API] clearAuthToken chamado');
    this.authToken = null;
    localStorage.removeItem('userHash');
  }

  async login(cpf, senha) {
    console.log('[API] login chamado para CPF:', cpf);
    try {
      // Usar URLSearchParams para form-data
      const params = new URLSearchParams();
      params.append('cpf', cpf);
      params.append('senha', senha);

      const response = await this.api.post('/login', params.toString(), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
      
      console.log('[API] Resposta do login:', response.data);
      
      if (response.data.sucesso && response.data.usuario?.hash) {
        await this.setAuthToken(response.data.usuario.hash);
      }
      
      return response.data;
    } catch (error) {
      console.error('[API] Erro no login:', error);
      if (axios.isAxiosError(error)) {
        return error.response?.data || {
          sucesso: false,
          mensagem: 'Erro ao conectar com o servidor',
        };
      }
      return {
        sucesso: false,
        mensagem: 'Erro desconhecido',
      };
    }
  }

  async getSolicitacaoDetalhe(id) {
    console.log('[API] Buscando solicitação detalhe ID:', id);
    try {
      const response = await this.api.get(`/solicitacoes/${id}`);
      return response.data;
    } catch (error) {
      console.error('[API] Erro ao buscar solicitação:', error);
      if (axios.isAxiosError(error)) {
        return error.response?.data || {
          sucesso: false,
          mensagem: 'Erro ao buscar detalhes da solicitação',
        };
      }
      return {
        sucesso: false,
        mensagem: 'Erro desconhecido',
      };
    }
  }

  async getSolicitacoes(params) {
    console.log('[API] Buscando solicitações com params:', params);
    try {
      const response = await this.api.get('/solicitacoes', { params });
      return response.data;
    } catch (error) {
      console.error('[API] Erro ao buscar solicitações:', error);
      if (axios.isAxiosError(error)) {
        return error.response?.data || {
          sucesso: false,
          mensagem: 'Erro ao buscar solicitações',
        };
      }
      return {
        sucesso: false,
        mensagem: 'Erro desconhecido',
      };
    }
  }

  async getHistorico(params) {
    console.log('[API] Buscando histórico com params:', params);
    try {
      const response = await this.api.get('/historico', { params });
      return response.data;
    } catch (error) {
      console.error('[API] Erro ao buscar histórico:', error);
      if (axios.isAxiosError(error)) {
        return error.response?.data || {
          sucesso: false,
          mensagem: 'Erro ao buscar histórico',
        };
      }
      return {
        sucesso: false,
        mensagem: 'Erro desconhecido',
      };
    }
  }

  async registrarAbastecimento(data) {
    console.log('[API] Registrando abastecimento:', data);
    try {
      const params = new URLSearchParams();
      params.append('id_abastecimento', String(data.id_abastecimento));
      params.append('litros', String(data.litros));
      if (data.geolocal) params.append('geolocal', data.geolocal);
      if (data.foto_visor) params.append('foto_visor', data.foto_visor);
      if (data.foto_cupom) params.append('foto_cupom', data.foto_cupom);

      const response = await this.api.post('/abastecer', params.toString(), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
      
      return response.data;
    } catch (error) {
      console.error('[API] Erro ao registrar abastecimento:', error);
      if (axios.isAxiosError(error)) {
        return error.response?.data || {
          sucesso: false,
          mensagem: 'Erro ao registrar abastecimento',
        };
      }
      return {
        sucesso: false,
        mensagem: 'Erro desconhecido',
      };
    }
  }

  async getCombustiveisFornecedor() {
    console.log('[API] Buscando dados de selects');
    try {
      const response = await this.api.get('/combustiveis-fornecedor');
      return response.data;
    } catch (error) {
      console.error('[API] Erro ao buscar selects:', error);
      if (axios.isAxiosError(error)) {
        return error.response?.data || {
          sucesso: false,
          mensagem: 'Erro ao buscar dados de selects',
        };
      }
      return {
        sucesso: false,
        mensagem: 'Erro desconhecido',
      };
    }
  }
}

// Criar instância única
export const apiService = new ApiService();

// Inicializar token automaticamente
apiService.loadAuthToken().then(token => {
  console.log('[API] Token inicializado:', !!token);
});